export default "__VITE_ASSET__DmxVDk84__"